<template>
  <div class="icon" :style="{ width: `${$attrs.width}px`, height: `${$attrs.height}px` }"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.icon {
  background-image: url("@/assets/discord-logo.png");
  background-size: cover;
  background-position: center;
}
</style>
